import { RoomClass } from 'proto/Offer/RoomClass';

const roomClassToUrlValueMap: Partial<Record<RoomClass, string>> = {
    [RoomClass.Standard]: 'standard',
    [RoomClass.Superior]: 'superior',
    [RoomClass.Deluxe]: 'deluxe',
    [RoomClass.Economy]: 'economy',
    [RoomClass.Premium]: 'premium',
};

const urlValueToRoomClassMap: Partial<Record<string, RoomClass>> =
    Object.fromEntries(
        Object.entries(roomClassToUrlValueMap).map(([key, value]) => [
            value,
            key as RoomClass,
        ])
    );

export const convertRoomClassToUrlValue = (roomClass: RoomClass) =>
    roomClassToUrlValueMap[roomClass];

export const convertUrlValueToRoomClass = (urlValue: string) =>
    urlValueToRoomClassMap[urlValue];
